module.exports = __webpack_public_path__ + "static/media/paypal.9ccdd6d3.svg";